import { render, staticRenderFns } from "./CustomerBought.vue?vue&type=template&id=68e468f4&scoped=true&lang=html"
import script from "./CustomerBought.vue?vue&type=script&lang=js"
export * from "./CustomerBought.vue?vue&type=script&lang=js"
import style0 from "./CustomerBought.vue?vue&type=style&index=0&id=68e468f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e468f4",
  null
  
)

export default component.exports